/*
 * Author: Dw
 * File Created: Tuesday, 24-11-12 02:41 pm
 * Last Modified: Friday, 24-11-29 04:23 pm, by Dw
 */

import { useEffect, useState } from 'react';

import { useRouter } from 'next/router';

import { AnimatePresence, motion } from 'framer-motion';

import { ProductImage } from '../../_modules/Payments/style';

interface SlideImageProps {
  images: { src: string; alt: string }[]; // 图片数组，包含 src 和 alt 属性
  interval?: number; // 轮播间隔时间，默认3秒
}

const SlideImage: React.FC<SlideImageProps> = ({ images, interval = 3000 }) => {
  const [index, setIndex] = useState(0);
  const { pathname } = useRouter();

  useEffect(() => {
    if (!pathname.includes('/landing/home')) return;

    // 使用 setInterval 定时切换图片
    const timer = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, interval);

    // 在组件卸载时清除定时器
    return () => {
      clearInterval(timer);
    };
  }, [images.length, interval, pathname]);

  return (
    <div style={{ position: 'relative', width: '100%', height: '70%' }}>
      <AnimatePresence initial={false}>
        {' '}
        {/* 使用 initial={false} 减少动画负担 */}
        <motion.div
          animate={{ opacity: 1, x: 0, scale: 1, rotateY: 0 }} // 渐入效果，恢复原大小
          exit={{ opacity: 0, scale: 0.8 }} // 原地淡出并缩小
          initial={{ opacity: 0, x: 100, scale: 0.95, rotateY: 10 }} // 从右侧淡入，略微缩小并旋转
          key={images[index]?.src ?? ''} // 使用当前图片的 src 作为 key
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex', // Flexbox 居中
            alignItems: 'center',
            justifyContent: 'center',
          }}
          transition={{
            opacity: { duration: 0.3 }, // 缩短淡出时间
            scale: { duration: 0.3 }, // 缩短缩小时间
            x: { duration: 0.5 }, // 进入时的平移时间
          }}>
          <ProductImage
            alt={images[index]?.alt ?? ''} // 设置 alt 属性
            height={430}
            priority
            sizes="100vw"
            src={images[index]?.src ?? ''} // 设置图片 src
            style={{ objectFit: 'cover', maxWidth: '100%', maxHeight: '100%' }} // 保持比例并限制大小
            width={582}
          />
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default SlideImage;
